module.exports = __webpack_public_path__ + "img/del_icon.18258147.png";